import { createContext } from "react";
import type { GetBemBlocksWith } from "@ebsco-ui/utils";
import { Variant } from "../enum";
import { Item } from "../dropdown";

export interface DropdownContextType {
  getBlocksWith: GetBemBlocksWith;
  getMenuProps: (additionalProps?: object) => object;
  getLabelProps: (additionalProps?: object) => object;
  getItemProps: (additionalProps?: object) => object;
  getDividerProps: (additionalProps?: object) => object;
  getSelectableDividerProps: (additionalProps?: object) => object;
  getIconProps: (additionalProps?: object) => object;
  getToggleButtonProps: (additionalProps?: object) => object;
  isOpen: boolean;
  selectedItem: Item | null;
  highlightedIndex: number;
  placeholder?: string;
  variant: keyof typeof Variant;
  isLoading: boolean;
  announceLoadingStart?: string;
  announceLoadingEnd?: string;
  loadingPlaceholder?: string;
  isMultiselect?: boolean;
}

export const DropdownContext = createContext<DropdownContextType | undefined>(
  undefined,
);

export default DropdownContext;
